/* eslint-disable jsx-a11y/no-static-element-interactions, react/prop-types */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { OPEN_CASE } from '../../home/constants/PropTypesShapes';
import { QuestionAlt } from '../../refundHelp/constants/svgSet';
import i18n from '../../lib/reacti18n';
import Page from '../../lib/page';
import contentHelper from '../../lib/contentHelper';
import { trackLink, trackPage } from '../../lib/analytics-helper';

const redirectClass = 'dispute-status-link';

const label = {
  disputeInfo: i18n.message('disputeHelp/disputeHelp.dispute.alert.info'),
};

class DisputeAlert extends Component {
  /**
   * Redirect URL FAQ for dispute alert
   * Checking in Remote config for FAQ or else redirect to hardcoded FAQ
   * @returns {string}
   */
  static reDirectUrl() {
    const disputeFaq = Page.getDisputeFaq() || 'FAQ1852';
    return `/smarthelp/article/${disputeFaq}`;
  }

  static getMarkup(content) {
    return { __html: content };
  }

  static getAlertInfo() {
    return contentHelper(label.disputeInfo, { user: Page.getUserFirstName(), link: DisputeAlert.reDirectUrl() });
  }

  static linkClickHandler(e) {
    e.preventDefault();
    if (e.target.className === redirectClass) {
      const pageId = Page.isContactUsPage() ? 'disputeContactInfo' : 'disputeSearchInfo';
      trackLink({ id: pageId, link: 'dispute-info|link|click', name: Page.getPageName() });
      window.open(DisputeAlert.reDirectUrl(), '_self');
    }
  }

  static renderDisputeAlert() {
    return (
      <div className="alert-container transaction-help__alert-container">
        <div className="transaction-help__alert-icon">{QuestionAlt()}</div>
        <div className="transaction-help__alert-content">
          <span
            onClick={DisputeAlert.linkClickHandler}
            dangerouslySetInnerHTML={DisputeAlert.getMarkup(DisputeAlert.getAlertInfo())}
          />
        </div>
      </div>
    );
  }

  /**
   * when disputes are loaded and user is part of elmo and current page is search or conntact-us fire FPTI
   * @param prevProps
   */
  componentDidUpdate(prevProps) {
    // when moving from, article page to search Pgae prevPropsElmo is not resetting and pageName is not updating
    if (
      prevProps.disputes !== this.props.disputes &&
      this.hasTransaction() &&
      this.isCurrentPageValidToDisplayAlert()
    ) {
      const pageId = Page.isContactUsPage() ? 'disputeContactInfo' : 'disputeSearchInfo';
      trackPage({ id: pageId, name: Page.getPageName(), link: 'dispute-alert' });
    }
  }

  isCurrentPageValidToDisplayAlert() {
    // Hiding Dispute Alert for Article, Home and Topic page
    // Enable dispute alert only for search and contactUs Page
    // For contactUs page display the alert only in root level.
    const { location, topicSelect } = this.props;
    const currentPath = location.pathname || location.pageName;
    const alertEnabledPaths = ['/search', 'contactUs'];

    if (currentPath) {
      if (Page.isContactUsPage()) {
        return topicSelect.layer === 1;
      }

      return alertEnabledPaths.includes(currentPath);
    }

    return false;
  }

  hasTransaction() {
    const { disputes } = this.props;
    return Array.isArray(disputes) && disputes.length > 0;
  }

  render() {
    // If no transactions or not valid path to display alert return null.
    if (!this.hasTransaction() || !this.isCurrentPageValidToDisplayAlert()) {
      return null;
    }

    // If has transactions and valid path to display alert then display dispute alert.
    return DisputeAlert.renderDisputeAlert();
  }
}

DisputeAlert.propTypes = {
  disputes: PropTypes.shape(OPEN_CASE),
};

DisputeAlert.defaultProps = {
  disputes: [],
};

const mapStateToProps = (state) => ({
  disputes: state.disputeTransactions.disputes,
  location: state.location,
  topicSelect: state.topicSelect,
});

export default connect(mapStateToProps)(DisputeAlert);
